import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { mapKey } from 'core/rx-js';
import { DsgDeepTranslationKey } from 'projects/designer/src/app/pipes/translate.pipe';
import { BehaviorSubject, filter } from 'rxjs';

export interface IFieldInfo {
  label: DsgDeepTranslationKey,
  value: any,
  display?: any,
  hidden?: boolean
}

@Component({
  selector: 'ss-process-review-field',
  templateUrl: './process-review-field.component.html',
  host: {
    class: 'mat-body-1 opacity-75'
  },
  styleUrls: ['./process-review-field.component.css'],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessReviewFieldComponent {

  readonly fieldInfoSubject = new BehaviorSubject<IFieldInfo>(null)
  @Input() get fieldInfo() {
    return this.fieldInfoSubject.value
  }
  set fieldInfo(value) {
    this.fieldInfoSubject.next(value)
  }

  readonly labelObs = this.fieldInfoSubject.pipe(
    filter(Boolean),
    mapKey('label')
  )

  readonly displayObs = this.fieldInfoSubject.pipe(
    filter(Boolean),
    mapKey('display')
  )

}

